// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"319":"b27a5b2d","381":"d784cac5","703":"09959c6e","787":"9bd820c7","820":"0f6bd840"}[chunkId] + ".chunk.js";
};